<section class="rooms-v2 hotel-card" id="rooms-section">
  <div #dynamicGallery style="display: none"></div>

  <!-- <div class="rooms-title px-4 py-3">
    <span class="rooms-title-text">Rooms</span>

    <div class="rooms-booked">
      <span class="ico">
        <img src="/assets/images/icons/booked.svg" alt="Booked by" />
      </span>
      <span class="label">BOOKED BY:</span>
      <span class="value">2100</span>
    </div>
  </div> -->

  <div class="rooms-list">
    @for (r of rooms; track r._id || r.id || $index; let i = $index) {
      <article class="room-card-v3 mb-3">
        <!-- Title + stats -->
        <div class="room-head">
          <h3 class="room-title">{{ r?.name }}</h3>

          <ul class="room-stats">
            <li *ngIf="r?.roomArea">
              <span class="ico">
                <img src="/assets/images/icons/room-area-v2.svg" alt="Area" />
              </span>
              <span class="txt">
                {{ r?.roomArea?.area }} {{ r?.roomArea?.unit | uppercase }}
              </span>
            </li>

          <ng-container *ngIf="maxOccupancy(r) as occ">
            <li *ngIf="occ.adults">
              <span class="ico">
                <img src="/assets/images/icons/guest-v2.svg" alt="maxGuestOccupancy" />
              </span>
              <span class="txt">
                {{ occ.adults }} Adult{{ occ.adults > 1 ? 's' : '' }}
              </span>
            </li>

            <li *ngIf="occ.children">
              <span class="ico">
                <img src="/assets/images/icons/child-icon.svg" alt="maxGuestOccupancy" />
              </span>
              <span class="txt">
                {{ occ.children }} Children
              </span>
            </li>
          </ng-container>

            <li *ngIf="r?.bedSize?.length">
              <span class="ico">
                <img src="/assets/images/icons/bed-v2.svg" alt="Bed" />
              </span>
              <span class="txt">{{ r?.bedSize.join(" | ") | titlecase }}</span>
            </li>
          </ul>
        </div>

        <div class="room-body">
          <!-- Left media -->
          <div class="media">
            <img
              class="hero"
              [src]="r?.banners?.[0]?.imageUrl"
              [alt]="r?.name"
              (click)="onOpenGallery(r, 0, $event)"
              (keydown.enter)="onOpenGallery(r, 0, $event)"
              tabindex="0"
            />

            <div class="thumb-row" *ngIf="hasThumbs(r)">
              <img
                class="thumb"
                *ngFor="let t of thumbs(r); let ti = index"
                [src]="t?.imageUrl"
                [alt]="r?.name + ' thumb'"
                (click)="onOpenGallery(r, ti + 1, $event)"
                (keydown.enter)="onOpenGallery(r, ti + 1, $event)"
                tabindex="0"
              />

              <button
                type="button"
                class="thumb view-more"
                *ngIf="showViewMoreThumb(r)"
                [style.backgroundImage]="viewMoreBg(r)"
                (click)="onOpenGallery(r, 0, $event)"
              >
                <span class="vm-text">
                  +{{ getRemainingBannerCount(r) }}<br />
                  More
                </span>
              </button>
            </div>
          </div>

          <!-- Right details -->
          <div class="details">
            <!-- <div class="amenities-wrap">
              <ul class="amenities">
                <li *ngFor="let a of amenitiesLeft(r)">
                  <i class="fa-solid fa-check"></i>
                  <span>{{ a?.name }}</span>
                </li>
              </ul>

              <ul class="amenities">
                <li *ngFor="let a of amenitiesRight(r)">
                  <i class="fa-solid fa-check"></i>
                  <span>{{ a?.name }}</span>
                </li>
              </ul>
            </div> -->

            <div class="amenities-wrap">
              <ul class="amenities two-col">
                @for (a of getVisibleAmenities(r); track a) {
                  <li>
                    <i class="fa-solid fa-check"></i>
                    <span>{{ a }}</span>
                  </li>
                }
              </ul>

              @if (mobileView && getAmenities(r).length > 5) {
                <div
                  class="view-toggle"
                  (click)="
                    expandedAmenities[r?.id || r?._id] =
                      !expandedAmenities[r?.id || r?._id]
                  "
                >
                  {{
                    expandedAmenities[r?.id || r?._id]
                      ? "View Less"
                      : "View More"
                  }}
                  <i
                    class="fa-solid"
                    [ngClass]="
                      expandedAmenities[r?.id || r?._id]
                        ? 'fa-chevron-up'
                        : 'fa-chevron-down'
                    "
                  ></i>
                </div>
              }
            </div>

            <!-- ✅ SAFE BUTTON (No javascript:void(0)) -->
            <!-- <button
              type="button"
              class="amenities-more"
              *ngIf="(getAmenities(r)?.length ?? 0) > 14"
              [matTooltip]="getRemainingAmenities(getAmenities(r) || []).join(', ')"
              matTooltipClass="amenities-tooltip"
              matTooltipPosition="right"
            >
              View More Amenities
            </button>

            <div class="occupancy" *ngIf="maxOccupancyText(r)">
              Maximum Occupancy {{ maxOccupancyText(r) }}
            </div> -->

            <!-- OPTIONAL: if you want check availability button (kept same event shape) -->
            <!--
            <button
              type="button"
              class="btn-check-availability"
              (click)="onBook(r, $event)"
            >
              CHECK AVAILABILITY
            </button>
            -->
            <div class="occupancy" *ngIf="r?.maxOccupancy?.maxGuestOccupancy">
              Maximum Occupancy {{ r?.maxOccupancy?.maxGuestOccupancy }} Guest{{
                r?.maxOccupancy?.maxGuestOccupancy > 1 ? "s" : ""
               }}
            </div>
          </div>
        </div>

        <!-- <div class="divider" *ngIf="i < rooms.length - 1"></div> -->
      </article>
    }
  </div>
</section>
